import * as React from 'react';

import {classify} from 'src/utils/classify';
import {ROW_TYPE} from 'src/types/byod';

import layoutCss from './dashboard-builder-canvas-layout.css';


export type TilePlaceholderProps = {
  rowType: string;
};

/**
 * Empty tile-sized slot rendered at the drop insertion point during a
 * cross-row drag. Reuses `tileDraggableFill` + the row-type variant so it
 * occupies the exact same flex footprint as a real tile — flex layout
 * then pushes every tile after the insertion point right by one
 * tile-width-plus-gap, giving the user "make room for the dragged tile"
 * feedback without enabling @dnd-kit's OptimisticSortingPlugin (which
 * would also move the source tile we want to keep visible as a ghost).
 *
 * Only rendered for cross-row drops. Same-row reorders show only the
 * vertical indicator line in tile-row.tsx — adding a placeholder there
 * would push tile count beyond row capacity (e.g. 5 visible slots in a
 * 4-cap KPI row).
 */
export function TilePlaceholder({rowType}: TilePlaceholderProps) {
  const isKpi = rowType === ROW_TYPE.KPI;
  return (
    <div
      aria-hidden
      className={classify(
        layoutCss.tileDraggableFill,
        isKpi ? layoutCss.tileDraggableFillKpi : layoutCss.tileDraggableFillViz,
        layoutCss.tilePlaceholder,
      )}
    />
  );
}
